<template>
    <ConfirmDialog
            :dialogTitle="dialogTitle"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'500px'"
    >
        <el-form :model="query" label-width="100px">
            <el-form-item label="协议商品确认:">
                <el-radio v-model="query.isConfirm" :label="1">确认</el-radio>
                <el-radio v-model="query.isConfirm" :label="0">拒绝</el-radio>
            </el-form-item>
            <el-form-item label="拒绝原因:" v-if="query.isConfirm == 0">
                <el-input type="textarea" :row="3" v-model="query.reason"></el-input>
            </el-form-item>
        </el-form>
    </ConfirmDialog>
</template>

<script>
    import { debounce } from "@/modules/projectA/utils/throttle.js"
    import ConfirmDialog from '../../../../../components/common/epecDialog'
    import Api from '../../../api/agreement/index'
    export default {
        name: "confirmDialog",
        components: {
            ConfirmDialog
        },
        props: {
            visible:{
                type:Boolean,
                required: true
            },
            agreementId:{
                type:Number,
                required: true
            },
            supplierCompanyId:{
                type:Number,
                required: true
            },
            selectedData:{
                type:Array,
                required: true
            }
        },
        data() {
            return {
                dialogTitle:'协议商品确认',
                query:{
                    isConfirm:1,
                    reason:''
                }

            }
        },
        computed: {},
        created() {
        },
        methods: {
            updateVisible(){
            },
            resetPopupData(){
                this.$emit('close')
                this.$emit('refresh')
            },
            submitPopupData(){
                debounce(() => {
                    if(this.query.isConfirm == 1){
                        let params = this.formatConfirmParams()
                        Api.agreementPricePurchasers4Confirm(params)
                            .then((res) => {
                                if(res.code == '200'){
                                    this.$message({
                                        type:'success',
                                        message:'确认价格成功'
                                    })
                                    this.$emit('close')
                                    this.$emit('refresh')
                                }
                            })
                    }else {
                        let params = this.formatRefuseParams()
                        Api.agreementPricePurchaser4Refuse(params)
                            .then((res) => {
                                if(res.code == '200'){
                                    this.$message({
                                        type:'success',
                                        message:'拒绝价格成功'
                                    })
                                    this.$emit('close')
                                    this.$emit('refresh')
                                }
                            })

                    }
                },500)


            },
            formatConfirmParams(){
                let res = this.selectedData
                if(res){
                    res.map((item,index) => {
                        res[index].agreementId = this.agreementId
                        res[index].supplierCompanyId = this.supplierCompanyId
                    })
                }
                return res
            },
            formatRefuseParams(){
                let res = {}
                res.agreementId = this.agreementId
                res.supplierCompanyId = this.supplierCompanyId
                this.$set(res,'priceId',[])
                if(this.selectedData){
                    this.selectedData.map((item) => {
                        res.priceId.push(item.priceId)
                    })
                }

                res.refuseReasons = this.query.reason
                return res
            }
        }

    }
</script>

<style scoped>

</style>
